module.exports = __webpack_public_path__ + "static/media/img92.f67b592b.png";